import React, { Component } from 'react';
import styles from './styles/signature.module.css';

class Signature extends Component {
  render() {
    return (
      <div className={styles.wrapper}>
        <div className="text-gray-300 flex items-baseline ">
          Powered by{' '}
          <img
            width={36}
            style={{ verticalAlign: 'middle' }}
            src={`${process.env.PUBLIC_URL}/elay.png`}
          ></img>{' '}
        </div>
      </div>
    );
  }
}

export default Signature;
